import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Grid } from '@mui/material';
import { useOperatorsUsersRolesMutation } from 'api/queries/operators';
import { ControlledField, SelectInputField } from 'remote/global';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { createRoleSelectOptions } from '../helpers';
import { AccountMemberSchemaType, accountMemberSchema } from './types';

type Props = {
  defaultValues?: Partial<AccountMemberSchemaType>;
  onClose: () => void;
};

function AccountEditMemberForm(props: Props) {
  const { defaultValues, onClose } = props;
  const tInstance = useTranslation();
  const { t } = tInstance;

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, isValidating, isLoading },
  } = useForm<AccountMemberSchemaType>({
    defaultValues,
    resolver: zodResolver(accountMemberSchema),
  });
  const roleMutation = useOperatorsUsersRolesMutation();

  const onValid = async (data: AccountMemberSchemaType) => {
    await roleMutation.mutateAsync({ id: String(data.id), role: data.role });
    toast.success(t('Toast.success'));
    onClose();
  };

  const roleOptions = createRoleSelectOptions(t);

  return (
    <form onSubmit={handleSubmit(onValid)}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ControlledField
            control={control}
            name='contactInfo.fullName'
            translationKey='name'
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledField
            control={control}
            name='role'
            render={(renderProps) => (
              <SelectInputField
                {...renderProps}
                options={roleOptions}
                fieldProps={{
                  autoFocus: true,
                }}
              />
            )}
          />
        </Grid>
        <Button
          type='submit'
          variant='contained'
          disabled={isSubmitting || isValidating || isLoading}
          fullWidth
          sx={{ mt: '2rem' }}
        >
          {t('save')}
        </Button>
      </Grid>
    </form>
  );
}

export default AccountEditMemberForm;
